import { useCallback } from "react";

import { audioBufferFromURL } from "astrid-helpers/src/audio/buffer/audioBuffer";
import useAsync from "astrid-hooks/src/useAsync";

export default function useBuffer(url) {
	return useAsync(useCallback(() => audioBufferFromURL(url), [url]));
}
